import React, { useEffect, useRef, useState } from "react";
import Colors from "../../../../Constants/Colors";
import Header from "../../../../Components/Header/Header";
import { apiCallGetAstrologerInvoiceList } from "../../../../Core/Apicall";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../../../Config/Actions/loadingActions";
import { useDispatch } from "react-redux";
import EmptyData from "../../../../Components/EmptyData/EmptyData";
import AstrologerInvoiceList from "../Usertransaction/AstrologerInvoiceList";
// import UseDebounce from "../../../../Components/UseDebounce";

function AstrologerInvoice() {
  const [searchValue, setSearchValue] = useState("");
  const [astrologerInvoiceData, setAstrologerInvoiceData] = useState([]);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageComments, setPageComments] = useState(1);
  const commentsContainerRef = useRef(null);
  const dispatch = useDispatch();
  // const debouncedInput = UseDebounce(searchValue, 500);

  useEffect(() => {
    setPageComments(1);
    setAstrologerInvoiceData([]);
    // const searchQuery = debouncedInput || searchValue;
    onApiCallAstrologerInvoice(1);
    // onApiCallAstrologerInvoice(searchQuery, 1);
  }, []);
  // }, [debouncedInput]);

  const onApiCallAstrologerInvoice = async (pageComments) => {
    try {
      // const onApiCallAstrologerInvoice = (item, pageComments) => {
      // const searchStatus = item || "";
      const param = {
        offset: pageComments,
        limit: 30,
        // search: searchStatus,
      };
      dispatch(setLoadingTrue());
      const response = await apiCallGetAstrologerInvoiceList(param);
      if (pageComments === 0) {
        setAstrologerInvoiceData(response?.data);
      } else {
        setAstrologerInvoiceData((prevData) => [
          ...prevData,
          ...response?.data,
        ]);
      }
      setTotalPageCount(Math.ceil(response.total / 30));
      dispatch(setLoadingFalse());
    } catch (error) {
      dispatch(setLoadingFalse());
    }
  };

  // const handleInputChange = (e) => {
  //   const searchText = e.target.value;
  //   setSearchValue(searchText);
  // };

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } =
      commentsContainerRef?.current;

    setTimeout(() => {
      if (scrollTop <= 100) {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      }
    }, 100);

    if (scrollTop + clientHeight + 1 >= scrollHeight) {
      if (totalPageCount > pageComments + 1) {
        setPageComments((prevPage) => {
          const nextPage = prevPage + 1;
          onApiCallAstrologerInvoice(searchValue, nextPage);
          return nextPage;
        });
      }
    }
  };

  return (
    <div
      style={{
        padding: 20,
        backgroundColor: Colors.darkBlack,
      }}
    >
      <Header name={"Transaction/Astrologer Invoice"} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          gap: "1rem",
        }}
      >
        <div className="sectionDivStyle">
          <div
            className="title24FontWeight400WHite"
            style={{
              flex: "1",
              position: "relative",
              alignSelf: "stretch",
              alignItems: "center",
              display: "flex",
            }}
          >
            Astrologer Invoice
          </div>
          {/* <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: "1rem",
              fontSize: "1rem",
              color: "rgba(255, 255, 255, 0.5)",
            }}
          >
            <div
              style={{
                borderRadius: "8px",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                boxSizing: "border-box",
                width: "15.75rem",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                padding: "0.5rem 0.5rem",
                gap: "0.5rem",
              }}
            >
              <img
                style={{
                  position: "relative",
                  width: "1.5rem",
                  height: "1.5rem",
                  objectFit: "contain",
                }}
                alt=""
                src={Icons.ic_search}
              />
              <input
                type="text"
                className="searchTextInput"
                placeholder="Search"
                value={searchValue}
                onChange={handleInputChange}
              />
            </div>
          </div> */}
        </div>

        <AstrologerInvoiceList
          handleScroll={handleScroll}
          commentsContainerRef={commentsContainerRef}
          data={astrologerInvoiceData}
          astrologerId={"Astrologer ID"}
          Astrologer={"Astrologer"}
          fromDate={"From Date"}
          totalIncome={"Total Income"}
          toDate={"To Date"}
          paidDate={"Paid Date"}
          status={"Status"}
        />
      </div>

      {astrologerInvoiceData.length <= 0 && <EmptyData />}
    </div>
  );
}
export default AstrologerInvoice;
